module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'outer-' + _vm.$route.name,
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "deveo-wrapper",
    class: _vm.$route.name
  }, [_c('top-menu'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('main-footer', {
    attrs: {
      "skew": _vm.skewFooter
    }
  }), _vm._v(" "), _c('mobile-footer'), _vm._v(" "), (_vm.$store.state.mobileMenu) ? _c('mobile-menu') : _vm._e(), _vm._v(" "), _c('vue-progress-bar'), _vm._v(" "), _c('cookie-notice')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab91d28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/layout/layout.vue
// module id = 300
// module chunks = 1